
jQuery(function($){
    $.validator.setDefaults({
      // debug: true,
      success: "valid"
    });
    $.extend(jQuery.validator.messages, {
        required: "入力してください。",
        remote: "Please fix this field.",
        email: "メールアドレスが正しいかご確認ください",
        url: "Please enter a valid URL.",
        date: "日付が正しいかご確認ください",
        dateISO: "Please enter a valid date (ISO).",
        number: "Please enter a valid number.",
        digits: "Please enter only digits.",
        creditcard: "Please enter a valid credit card number.",
        equalTo: "Please enter the same value again.",
        accept: "Please enter a value with a valid extension.",
        maxlength: jQuery.validator.format("Please enter no more than {0} characters."),
        minlength: jQuery.validator.format("Please enter at least {0} characters."),
        rangelength: jQuery.validator.format("Please enter a value between {0} and {1} characters long."),
        range: jQuery.validator.format("Please enter a value between {0} and {1}."),
        max: jQuery.validator.format("Please enter a value less than or equal to {0}."),
        min: jQuery.validator.format("Please enter a value greater than or equal to {0}.")
    });
    
    $.validator.addMethod("isBirthday", function (value, element) {
      return this.optional(element)
              || /^([0-9]{4})([0-9]{1,2}|1[0-2])([0-9]{1,2}|1[0-9]|2[0-9]|3[0-1])$/.test(value)
              || /^([0-9]{4})\.([0-9]{1,2}|1[0-2])\.([0-9]{1,2}|1[0-9]|2[0-9]|3[0-1])$/.test(value)
              || /^([0-9]{4})\/([0-9]{1,2}|1[0-2])\/([0-9]{1,2}|1[0-9]|2[0-9]|3[0-1])$/.test(value)
              || /^([0-9]{4})\-([0-9]{1,2}|1[0-2])\-([0-9]{1,2}|1[0-9]|2[0-9]|3[0-1])$/.test(value)
      ;
    }, "生年月日をご確認ください。");
    $.validator.addMethod('isPhone', function(value, element){
      return this.optional(element) || /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/.test(value.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi,''));
    }, '電話番号をご確認ください。');
    $.validator.addMethod("isZip", function(value, element) {
      return this.optional( element ) || /^\d{3}-?\d{4}$/.test( value );
    }, '郵便番号をご確認ください。');
    $('.b_recruitForm form').validate({
      //検証ルール設定
      rules: {
        'お名前': {
          required: true,
        },
        'お名前(フリガナ)': {
          required: true,
        },
        '生年月日': {
          required: true,
          isBirthday: true
        },
        '性別': {
          required: true,
        },
        '写真': {
          required: true,
        },
        'お電話番号': {
          required: true,
          isPhone: true,
        },
        '郵便番号': {
          required: true,
          isZip: true,
        },
        'ご住所': {
          required: true,
        },
        'メールアドレス': {
          required: true,
          email: true,
        },
        '最終学歴[]': {
          required: true,
        },
        '学校名': {
          required: true,
        },
        '配偶者': {
          required: true,
        },
        '扶養人数': {
          required: true,
        },
        '希望雇用形態': {
          required: true,
        },
        '希望職種': {
          required: true,
        },
        '自己PR': {
          required: true,
        },
      },
      //エラーメッセージ設定
      messages: {
        '生年月日': {
          dateISO: '日付を正確に入力してください'
        },
        '性別': {
          required: '選択してください'
        },
        '写真': {
          required: '選択してください'
        },
        '最終学歴': {
          required: '選択してください'
        },
        '配偶者': {
          required: '選択してください'
        },
        '希望職種': {
          required: '選択してください'
        },
      },
      //エラーメッセージ出力箇所設定
      errorPlacement: function(error, element){
        //ラジオボタンの例
        if (
            element.attr('name') === '配偶者'
            || element.attr('name') === '希望雇用形態'
        ){
            error.insertAfter(element.parents('.e_form_radio'));
        //チェックボックスの例
        } else if ( element.attr('name') === '写真'){
            error.insertAfter(element.parents('.e_form_file'));
        //標準出力箇所（フォーム項目の後にエラーメッセージを出力）
        } else if ( element.attr('name') === '最終学歴'){
            error.insertAfter(element.parents('.b_recruitForm_itemInput2column'));
        } else {    
            error.insertAfter(element);
        }
      }
    });
  });